'use client';

import get from 'lodash/get';
import React, { useState } from 'react';
import { SearchOutlined, EyeOutlined, DownloadOutlined, CalendarOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';
import { BASE_FILE_URL, COLORS } from '@/common/constants';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { twMerge } from 'tailwind-merge';
import { formatDateVN } from '@/common/ultils';

const BangDuThao = (props) => {
  const { draftProposals, websiteCode } = props;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const totalPages = draftProposals?.totalPages || 0;
  const page = draftProposals?.page || 1;
  const t = useTranslations('');

  const [openCollapseList, setOpenCollapseList] = useState(false);

  const handleSearch = (search) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('search', search);
    newParams.set('page', 1);
    router.push(`${pathname}?${newParams.toString()}`);
  };
  const handleChangePage = (page) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page);
    router.push(`${pathname}?${newParams.toString()}`);
  };

  const getPageNumbers = () => {
    const page = [];
    const delta = 2;

    if (totalPages <= 7) {
      // Hiển thị toàn bộ
      for (let i = 1; i <= totalPages; i++) page.push(i);
    } else {
      page.push(1);

      if (page > delta + 2) {
        page.push('...');
      }

      for (let i = Math.max(2, page - delta); i <= Math.min(totalPages - 1, page + delta); i++) {
        page.push(i);
      }

      if (page < totalPages - (delta + 1)) {
        page.push('...');
      }

      page.push(totalPages);
    }

    return page;
  };

  const pageNumbers = getPageNumbers();

  const handleViewAll = (item) => {
    if (websiteCode) {
      router.push(`/sub/${websiteCode}/du-thao/${item?.slug}`);
    } else {
      router.push(`/du-thao/${item?.slug}`);
    }
    // Add your view all logic here
  };
  const handleViewComments = (item) => {
    if (websiteCode) {
      router.push(`/sub/${websiteCode}/du-thao/${item?.slug}/phan-hoi`);
    } else {
      router.push(`/du-thao/${item?.slug}/phan-hoi`);
    }
    // Add your view comments logic here
  };

  const handleSendComments = (item) => {
    if (websiteCode) {
      router.push(`/sub/${websiteCode}/du-thao/${item?.slug}`);
    } else {
      router.push(`/du-thao/${item?.slug}`);
    }
    // Add your send comments logic here
  };

  return (
    <>
      <h1 className={twMerge('text-2xl bg-white mb-0 py-3 font-bold uppercase', COLORS.primary)}>{t('draftCmt.titleHeadingPage')}</h1>
      <div className="relative max-w-md hidden">
        <SearchOutlined className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder={t('home.searchPlahoder')}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch(e.target.value);
            }
          }}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="divide-y divide-gray-200 space-y-2">
        {get(draftProposals, 'results', []).map((draft) => (
          <div key={draft?.id} className="p-6 hover:bg-gray-50 transition-colors border-2 rounded-lg border-blue-600">
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0 pr-4">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="flex items-center text-sm text-gray-500">
                    <CalendarOutlined className="mr-1" />
                    <span>{formatDateVN(draft?.date)}</span>
                  </div>
                </div>
                <h3 className="text-lg font-medium text-gray-900 leading-tight mb-3">{draft.title}</h3>
              </div>
              <div className="flex flex-col space-y-2 ml-4">
                <button
                  onClick={() => handleViewAll(draft)}
                  className="inline-flex items-center px-4 py-2 text-sm font-medium 
                          text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors cursor-pointer">
                  <EyeOutlined className="mr-2" />
                  {t('draftCmt.viewAll')}
                </button>
                <button
                  className="inline-flex items-center px-4 py-2 text-sm font-medium 
                        text-gray-600 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
                  onClick={() => setOpenCollapseList(draft.id)}>
                  <DownloadOutlined className="mr-2" />
                  {t('media.download')}
                </button>
                <div className="flex space-x-1 pt-2">
                  <button className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer" onClick={() => handleViewComments(draft)}>
                    {t('draftCmt.viewComments')}
                  </button>
                  <span className="text-gray-400">|</span>
                  <button onClick={() => handleSendComments(draft)} className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer">
                    {t('draftCmt.sendCmt')}
                  </button>
                </div>
              </div>
            </div>
            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                openCollapseList === draft?.id ? 'max-h-[1000px] mt-4' : 'max-h-0'
              }`}>
              <ul className="space-y-2">
                {draft?.fileUrls?.length === 0 ? (
                  <li className="text-sm text-gray-500">{t('draftCmt.noFileDocument')}</li>
                ) : (
                  draft?.fileUrls?.map((file, index) => {
                    return (
                      <li key={index} className="p-3 bg-gray-100 rounded-md hover:bg-gray-200 space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-800 truncate max-w-[500px]">{file}</span>
                          <div className="flex items-center space-x-3">
                            <a
                              href={`${BASE_FILE_URL}/${file}`}
                              download
                              className="inline-flex items-center text-blue-600 hover:underline text-sm cursor-pointer">
                              <DownloadOutlined className="mr-1" /> {t('draftCmt.download')}
                            </a>
                          </div>
                        </div>
                      </li>
                    );
                  })
                )}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-end mr-5 mt-6 mb-2 space-x-2 items-center">
        <button
          onClick={() => page > 1 && handleChangePage(page - 1)}
          disabled={page === 1}
          className="px-2 py-1 rounded-md bg-gray-100 hover:bg-gray-200 disabled:opacity-50">
          <LeftOutlined />
        </button>

        {pageNumbers.map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === 'number' && handleChangePage(page)}
            className={`px-3 py-1 rounded-md text-sm ${
              page === page
                ? 'bg-blue-600 text-white'
                : typeof page === 'number'
                ? 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                : 'cursor-default text-gray-500'
            }`}
            disabled={page === '...'}>
            {page}
          </button>
        ))}

        <button
          onClick={() => page < totalPages && handleChangePage(page + 1)}
          disabled={page === totalPages}
          className="px-2 py-1 rounded-md bg-gray-100 hover:bg-gray-200 disabled:opacity-50">
          <RightOutlined />
        </button>
      </div>
    </>
  );
};

export default BangDuThao;
